module.exports = __webpack_public_path__ + "static/media/access-sec.732d0fd9.svg";